const HTML_ESCAPES: Record<string, string> = {
  '"': '&quot;',
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
};

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"]/g, c => HTML_ESCAPES[c] ?? c);
}
